var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[1.12]-Multiple-Pole-Price-Changes---Showing-custom-date-picker",
    transform: "translate(-909.000000, -680.000000)",
    fill: "#72818F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stations-List-/-Price-Edit-Bar",
    transform: "translate(80.000000, 657.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838,23 C833.037464,23 829,27.037464 829,32 C829,36.962536 833.037464,41 838,41 C842.962536,41 847,36.962536 847,32 C847,27.037464 842.962502,23 838,23 Z M838.585423,37.3399194 C838.157841,37.4112003 837.307037,37.5892308 836.874991,37.6250086 C836.509282,37.6552927 836.164174,37.445948 835.953799,37.1454421 C835.742875,36.8449706 835.692333,36.4604453 835.817555,36.1154747 L837.518785,31.4375129 L835.749983,31.4375129 C835.748472,30.4627572 836.479616,29.7460342 837.414748,29.4709711 C837.861009,29.3396714 838.692448,29.1599928 839.124974,29.18753 C839.384106,29.2040112 839.835792,29.3665906 840.046166,29.6670965 C840.25709,29.967568 840.307632,30.3520933 840.18241,30.6970639 L838.48118,35.3750258 L840.249433,35.3750258 C840.249777,36.3486483 839.545895,37.1798465 838.585423,37.3399194 L838.585423,37.3399194 Z M839.124974,28.6250086 C838.503636,28.6250086 837.999966,28.1212698 837.999966,27.5 C837.999966,26.8786615 838.503636,26.3749914 839.124974,26.3749914 C839.746313,26.3749914 840.249983,26.8786615 840.249983,27.5 C840.249983,28.1213041 839.746347,28.6250086 839.124974,28.6250086 Z",
    id: "Info-Icon-Copy"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.95675f5b.svg";
export { ForwardRef as ReactComponent };